import React from 'react';

import Popup from 'OldComponents/Popup';
import Papa from 'papaparse';
import Types from 'FielderUtils/forms/types';
import { useLanguage } from 'Context/LanguageContext';
import { Row, Col} from 'react-bootstrap';
import { Alert } from '@mui/material'
import { useDispatch } from 'react-redux';
import { getFormByIdRequest, } from '@core/api/form/form.service';


const DowloadFormTemplate = ({ setViewImport, viewImport, idFormTemplate, nameFormTemplate }) => {
  const lan = useLanguage();
  const dispatch = useDispatch();
  const QUESTIONS_INFO = [
    { name: lan.checkbox, value: lan.optionToSelect },
    { name: lan.radioButton, value: lan.optionsToSelect },
    { name: lan.textFieldQuestion, value: lan.text },
    { name: lan.numericRating, value: lan.numberInsideRatingValue },
    { name: lan.binaryRating, value: lan.positiveOrNegative },
    { name: lan.starsRating, value: lan.starsRatingRange },
    { name: lan.photograph, value: lan.notAvailableForUpdate },
    { name: lan.barcode, value: lan.insertBarcode },
    { name: lan.dateHour, value: lan.insertDateInFormFormat },
    { name: lan.textFile, value: lan.notAvailableForUpdate },
    { name: lan.eSignature, value: lan.notAvailableForUpdate },
    { name: lan.qrCode, value: lan.notAvailableForUpdate },
    { name: lan.catalogue, value: lan.optionsCatalogue },
    { name: lan.inventory, value: lan.text },
    { name: lan.asset, value: lan.text },
  ];
  
  const getFieldType = (field) => {
    switch (parseInt(field.type)) {
      case Types.CHECKBOX:
      case Types.MULTIPLE_CHOICE:
        return field.singleAnswer ? lan.radioButton : lan.checkbox;
      case Types.TEXT_FIELD:
        return lan.textFieldQuestion;
      case Types.NUMERIC_RATING:
        return lan.numericRating;
      case Types.BINARY_RATING:
        return lan.binaryRating;
      case Types.STARS_RATING:
        return lan.starsRating;
      case Types.CODEBAR_TEXT:
        return lan.barcode;
      case Types.DATE_HOUR:
        return lan.dateHour + ' ' + field.dateFormat;
      case Types.CATALOGUE:
        return lan.catalogue;
      case Types.INVENTORY:
        return lan.inventory;
      case Types.ASSET:
        return lan.asset;
      default:
        return '';
    }
  };

  const getCsvHeaders = (formFields) => {
    console.log('Generating CSV headers...');
    console.log('Form Fields:', formFields);
    const csvData = [];
    csvData.push([lan.idTaskName]);
    csvData.push([`${lan.idForm}: (${idFormTemplate}) ${nameFormTemplate}`]);
    formFields.forEach((field) => {
      const question = field.question;
      if (
        parseInt(question.type) !== Types.ELECTRONIC_SIGNATURE &&
        parseInt(question.type) !== Types.FILES &&
        parseInt(question.type) !== Types.CODEBAR_IMG &&
        parseInt(question.type) !== Types.TEXT_FILE
      ) {
        csvData.push([`${question.id} - ${question.title} [${getFieldType(question)}]`]);
      }
    });
    console.log('Generated CSV headers:', csvData);
    return csvData;
  };

  const handleExportCSVTemplate = () => {
    const body = { formId: idFormTemplate };
    const onSuccess = (response) => {
      const formFields = response.template.fields;
      try {
        const headers = getCsvHeaders(formFields);
        const csv = Papa.unparse({ fields: headers, data: [] });
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${nameFormTemplate}-sample.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('CSV generation error:', error);
      }
    };
    const loadingConfig = { dispatch };
    getFormByIdRequest(body, onSuccess, null, loadingConfig);
  };

  const ExampleLabel = ({ name, value }) => (
    <Row>
      <Col sm={4}>
        <span className='Fielder-label-input'>{name}</span>
      </Col>
      <Col sm='auto'>
        <span className='itallic Fielder-label-input Fielder-grey-color'>{value}</span>
      </Col>
    </Row>
  );

  return (
    <>
      {viewImport && (
        <Popup
          icon='excel-logo-icon.png'
          show
          width='lg'
          closeButton
          title={lan.updateFormInTaskByCsv}
          onClose={() => setViewImport(false)}
        >
          <Row>
            <Col>{lan.updateFormInfo}</Col>
          </Row>

          <Row className='mt-2 mb-4'>
            <Col>
              {QUESTIONS_INFO.map((element, index) => (
                <ExampleLabel key={index} {...element} />
              ))}
            </Col>
          </Row>

          <Row className='my-2'>
            <Col className='mx-auto'>
              <Alert severity='warning'>
                <Col>
                  <Row className='mb-2'>
                    <span className='small-popup-label'>{lan.rememberCsvFile}</span>
                  </Row>
                  <Row>
                    <span className='small-popup-label'>{lan.useCorrectCsvUpdateTemplate}</span>
                  </Row>
                  <Row>
                    <span className='small-popup-label'>{lan.cellsLeftBlankInfo}</span>
                  </Row>
                </Col>
              </Alert>
            </Col>
          </Row>

          <button
            className='myoperation-link my-2'
            style={{ background: 'none', border: 'none' }}
            onClick={handleExportCSVTemplate}
          >
            <u>{lan.downloadCSVTemplateCategory}</u>
          </button>
        </Popup>
      )}
    </>
  );
};

export default DowloadFormTemplate;
